import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _uniqueId from 'lodash/uniqueId';
import { DropDownDefault, DropDownMultiSelect } from "../../index";
import './dropdown.scss';

export const DropDown = React.forwardRef(({
    autoFocus = false,
    colorStyle = 'neutral',
    disabled = false,
    disabledOptions,
    error = false,
    hintMsg,
    id,
    label,
    name,
    onBlur = () => { },
    onChange = () => { },
    onDeselectAllClick = () => { },
    onSelectAllClick = () => { },
    options,
    multiselect = false,
    multiselectCount,
    required = false,
    selectedOptions,
    showSelectAll = false,
    value,
    ...inputProps
}, ref) => {

    const dropdownRef = ref ? ref : useRef();
    const [uId] = useState(_uniqueId('dropdown-'));
    const fieldId = id ? id : uId;
    const _colorStyle = error ? "error" : colorStyle;
    const labelText = label ? `${label}${!required ? ' (Optional)' : ''}` : '';

    return (multiselect
        ? <DropDownMultiSelect
            {...inputProps}
            ref={dropdownRef}
            autoFocus={autoFocus}
            colorStyle={_colorStyle}
            disabled={disabled}
            disabledOptions={disabledOptions}
            hintMsg={hintMsg}
            id={fieldId}
            label={labelText}
            multiselectCount={multiselectCount}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            onDeselectAllClick={onDeselectAllClick}
            onSelectAllClick={onSelectAllClick}
            options={options}
            required={required}
            selectedOptions={selectedOptions}
            showSelectAll={showSelectAll}
        />
        : <DropDownDefault
            {...inputProps}
            ref={dropdownRef}
            autoFocus={autoFocus}
            colorStyle={_colorStyle}
            disabled={disabled}
            hintMsg={hintMsg}
            id={fieldId}
            label={labelText}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            options={options}
            required={required}
            value={value}
        />
    )
})

DropDown.propTypes = {
    autoFocus: PropTypes.bool,
    colorStyle: PropTypes.string,
    disabled: PropTypes.bool,
    disabledOptions: PropTypes.array,
    error: PropTypes.bool,
    hintMsg: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onDeselectAllClick: PropTypes.func,
    onSelectAllClick: PropTypes.func,
    options: PropTypes.array,
    multiselect: PropTypes.bool,
    multiselectCount: PropTypes.number,
    required: PropTypes.bool,
    value: PropTypes.string,
    selectedOptions: PropTypes.array,
    showSelectAll: PropTypes.bool,
}
